import { render, staticRenderFns } from "./accountDetailsHsbc.vue?vue&type=template&id=6a0782dc&scoped=true"
import script from "./accountDetailsHsbc.vue?vue&type=script&lang=js"
export * from "./accountDetailsHsbc.vue?vue&type=script&lang=js"
import style0 from "./accountDetailsHsbc.vue?vue&type=style&index=0&id=6a0782dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0782dc",
  null
  
)

export default component.exports